import { useStoreSystem } from '@/store/system';
const store = useStoreSystem();

// 表示モード
export function storeSetDisplayMode(display_mode) {
    store.display_mode = display_mode
}
export function storeGetDisplayMode() {
    return store.display_mode
}

// 通知バー
export function storeSetBeforeNoticeBarKey(notice_key) {
    store.before_notice_bar_key = notice_key
}
export function storeGetBeforeNoticeBarKey() {
    return store.before_notice_bar_key
}

// 本日のタスク表示制御
export function storeSetTodayTaskDisplaySetting(display_setting) {
    store.todaytask_display_setting = display_setting
}
export function storeGetTodayTaskDisplaySetting() {
    return store.todaytask_display_setting;
}

// ルーティング情報
export function storeSetRoute(route) {
    store.route = route
}
export function storeGetRoute() {
    return store.route;
}
export function storeSetRouter(router) {
    store.router = router
}
export function storeGetRouter() {
    return store.router;
}

export default {
    storeSetDisplayMode,
    storeGetDisplayMode,
    storeSetBeforeNoticeBarKey,
    storeGetBeforeNoticeBarKey,
    storeSetTodayTaskDisplaySetting,
    storeGetTodayTaskDisplaySetting,

    storeSetRoute,
    storeGetRoute,
    storeSetRouter,
    storeGetRouter,
}